// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T18:11:53.151Z
// Property: Arctic Sun (ID: 6767906449167170)
// Collections: 13 amenities, 5 floorplans (live), 13 photos, 74 POIs, 3 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167170",
  "property_external_id": "1101827",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/arctic-sun/5XrD28/",
  "property_apartments_url": "https://www.apartments.com/arctic-sun-anchorage-ak/tyc4rh9/",
  "property_google_business_url": "https://www.google.com/maps/place/Arctic+Sun/data=!4m2!3m1!1s0x0:0x45cd4869576d620e?sa=X&ved=2ahUKEwjN1Zn45oOTAxVvAHkGHZQBLXoQ_BJ6BAhCEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47676658716",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "arctic-sun",
  "property_name": "Arctic Sun",
  "property_website_url": "https://alaska.weidner.com/apartments/ak/anchorage/arctic-sun-0/",
  "property_domain": "https://www.arcticsunapartments.com",
  "property_address": "625 W 46th Ave",
  "property_full_address": "625 W 46th Ave, Anchorage, AK 99503",
  "property_address_1": "625 W 46th Ave",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99503",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Midtown",
  "property_address_latitude": "61.17928373014373",
  "property_address_longitude": "-149.8957722475572",
  "property_email": "arcticsun@weidner.com",
  "property_phone": "(907) 308-5019",
  "property_call_tracking_phone": "907-308-5019",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Arctic Sun in Anchorage, AK, where comfort meets convenience. Choose from spacious one- or two-bedroom layouts featuring large walk-in closets, modern kitchens, and outdoor patios. Enjoy 24-hour access to amenities, a picturesque courtyard, and a smoke-free environment. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Welcome to Arctic Sun Apartments – Your Ideal Home in Anchorage, AK!**\n\nDiscover the perfect blend of comfort and convenience at Arctic Sun Apartments, where modern living meets stunning natural beauty. Nestled in the heart of Anchorage, our community offers spacious floor plans, including cozy one-bedroom and generous two-bedroom options designed to cater to your unique lifestyle.\n\nAt Arctic Sun, we prioritize your comfort and well-being with an array of exceptional amenities. Enjoy 24-hour access to our community, complete with on-site maintenance and a dedicated property manager to assist with your needs. Take advantage of our convenient laundry facilities and make life easier with online payments and service requests. Spend sunny afternoons in our beautifully landscaped courtyard or let the kids enjoy the playground!\n\nStep inside your apartment, and you’ll appreciate features like large walk-in closets, patio or balcony access*, and stunning views* that bring the beauty of Alaska right to your doorstep. Our smoke-free community also includes modern kitchens with dishwashers, dining areas, and cozy ceiling fans for your comfort.\n\nWhether you're enjoying a peaceful evening in your spacious living room or soaking in the scenery from your patio, Arctic Sun Apartments is crafted for everyday living.\n\nDon't miss your chance to call Arctic Sun your home! Browse our availability or schedule a tour today to explore all that our community has to offer. Embrace life in Anchorage and find your new sanctuary at Arctic Sun Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9083-76c9-b184-4c97e615a155.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with sectional sofa, coffee table, and TV.",
    "public_id": "019d021b-9083-76c9-b184-4c97e615a155",
    "storage_key": "property/6767906449167170/019d021b-9083-76c9-b184-4c97e615a155.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "110",
  "property_year_built": "1977",
  "property_year_renovated": null,
  "property_walk_score": "68",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.72727272727272",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/arctic-sun-0/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/arctic-sun-0/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/arctic-sun-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140b5-9316-7448-8695-6d4e7979213a.webp",
  "property_primary_logo_media": {
    "alt_text": "Arctic Sun Apartment Homes logo",
    "public_id": "01a140b5-9316-7448-8695-6d4e7979213a",
    "storage_key": "property/6767906449167170/01a140b5-9316-7448-8695-6d4e7979213a.webp",
    "width": 119,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140b5-cbd9-7319-97c5-6be3c5aa49e5.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a140b5-cbd9-7319-97c5-6be3c5aa49e5",
    "storage_key": "property/6767906449167170/01a140b5-cbd9-7319-97c5-6be3c5aa49e5.webp",
    "width": 119,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140b5-c02d-73b8-8131-9e6af6e10a5e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a140b5-c02d-73b8-8131-9e6af6e10a5e",
    "storage_key": "property/6767906449167170/01a140b5-c02d-73b8-8131-9e6af6e10a5e.webp",
    "width": 119,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#2c2420",
  "property_secondary_color": "#b8922a",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ea9310",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 1100",
  "property_sqft_min": "800",
  "property_sqft_max": "1100",
  "property_price_range": "940 - 1690",
  "property_price_min": "940",
  "property_price_max": "1690",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/ArcticSunApartments",
  "property_instagram_url": "https://www.instagram.com/articsunapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe0xQaOuXyFYRDmJtV2lIzUU",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Arctic Sun",
  "property_home_romance_title": "Love Where You Live: Your Perfect Apartment Awaits!",
  "property_home_amenities_blurb": "Welcome to Arctic Sun, your haven in Anchorage, AK! Choose from spacious one or two-bedroom layouts featuring large walk-in closets and private patios. Enjoy 24-hour access, serene courtyards, and a smoke-free environment. Experience convenience with on-site maintenance and online services that elevate your lifestyle. Join us today!",
  "property_home_floorplans_blurb": "At Arctic Sun in Anchorage, AK, each apartment home is designed with your comfort in mind. From cozy one-bedrooms to spacious multi-bed options, our thoughtfully crafted floor plans cater to every lifestyle. Browse our available units today and let the stunning Alaskan landscape inspire your next home!",
  "property_home_gallery_blurb": "At Arctic Sun in Anchorage, AK, modern living meets comfort. Choose from spacious one or two-bedroom floor plans designed for your lifestyle. Enjoy 24-hour access, a courtyard playground, and high-speed internet, all within a gated community. Picture yourself relaxing on your private balcony or unwinding in your walk-in closet!",
  "property_home_neighborhood_blurb": "At Arctic Sun in Anchorage, AK, enjoy the perfect blend of comfort and adventure. Choose from spacious one or two-bedroom floor plans and immerse yourself in local culture. With the Anchorage Museum, Alaska Zoo, and sprawling parks just moments away, life here is vibrant and full of exploration.",
  "property_home_reviews_blurb": "At Arctic Sun in Anchorage, AK, residents bask in the glow of a vibrant community. One delighted resident raves, “Living here feels like home with breathtaking views and friendly neighbors.” Curious about life in our welcoming community? See what our residents have to say about living at Arctic Sun!",
  "property_neighborhood_blurb": "Nestled in vibrant Anchorage, Arctic Sun offers spacious one and two-bedroom floor plans, combining comfort with convenience. Just steps away, embrace nature at Kincaid Park or immerse yourself in Alaskan culture at the Anchorage Museum. See what's around our community and uncover local treasures and experiences waiting for you!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Arctic Sun in Anchorage, AK, life shines brighter with thoughtfully designed one and two-bedroom apartments. Revel in comfort with large walk-in closets, airy patios, and a vibrant courtyard. Enjoy 24-hour access, convenient online payments, and on-site management, all within a smoke-free environment. Your ideal home awaits!",
  "property_applynow_blurb": "At Arctic Sun in Anchorage, AK, elevate your lifestyle with spacious one and two-bedroom apartments featuring modern amenities like large walk-in closets, patios, and high-speed internet. Enjoy 24-hour access, on-site management, and a beautiful courtyard. Ready to embrace comfort? Secure your new home online today!",
  "property_contactus_blurb": "At Arctic Sun in Anchorage, AK, our thoughtfully designed one- and two-bedroom floor plans offer the perfect blend of comfort and style. Each space invites warmth and tranquility, making it your ideal retreat. Have questions? Contact our leasing team today to learn more about your future home!",
  "property_faqs_blurb": "At Arctic Sun in Anchorage, AK, we offer thoughtfully designed one and two-bedroom floor plans that cater to your unique lifestyle. Ready to learn more? Visit our FAQs page for answers to common queries about our vibrant community and discover how Arctic Sun can be your next home sweet home!",
  "property_floorplans_blurb": "At Arctic Sun in Anchorage, AK, our thoughtfully designed floor plans cater to your every need. Choose from spacious one-bedroom or two-bedroom apartments, each offering a blend of comfort and modern style. Browse our available homes today and find the perfect layout to elevate your lifestyle in the Last Frontier!",
  "property_gallery_blurb": "At Arctic Sun in Anchorage, AK, picture your ideal lifestyle where comfort meets convenience. Choose from spacious one or two-bedroom floor plans featuring large walk-in closets, private patios, and inviting skylights. With amenities like 24-hour access, on-site maintenance, and a serene courtyard, your dream home awaits—immerse in the gallery now!",
  "property_interactivemap_blurb": "At Arctic Sun in Anchorage, AK, your perfect home awaits! Choose from spacious one and two-bedroom floor plans featuring modern amenities, including large walk-in closets, balconies, and high-speed internet. With 24-hour access, on-site management, and a secure, smoke-free environment, comfort and convenience are just a click away!",
  "property_pets_blurb": "At Arctic Sun in Anchorage, AK, your furry friends are embraced! With no weight limit and room for two, cats and dogs can frolic freely. Enjoy a vibrant community while our pet-friendly amenities cater to your four-legged companions. Unleash joy in a space designed for both pets and people!",
  "property_referafriend_blurb": "At Arctic Sun in Anchorage, AK, great friends make great neighbors! Our inviting one and two-bedroom floor plans are designed for comfort and connection. Share the joy of community living—refer a friend today and create lasting memories together in your perfect home under the Alaskan sky!",
  "property_residentaccess_blurb": "Welcome to Arctic Sun in Anchorage, AK, where comfort meets convenience. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Gain seamless access to essential services through our resident portal—effortlessly pay rent, schedule maintenance, and engage with your community. Your Arctic Sun experience begins here!",
  "property_reviews_blurb": "At Arctic Sun in Anchorage, AK, our residents describe their experience as “a perfect blend of comfort and community.” Dive into our reviews to discover the warmth of life in our vibrant apartment community. See what our residents have to say about living at Arctic Sun! ",
  "property_created_at": "1771535496350",
  "property_scheduletour_blurb": "At Arctic Sun, located in the picturesque Anchorage, AK, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and convenience. Schedule a tour today, and hear firsthand from our residents about the vibrant lifestyle and welcoming community waiting just for you!",
  "property_thankyou_blurb": "Thank you for reaching out to Arctic Sun in vibrant Anchorage, AK! We offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Our team is excited to assist you in finding your perfect home. Stay tuned for our prompt response, and welcome to your new community!",
  "property_virtualtours_blurb": "Nestled in the heart of Anchorage, AK, Arctic Sun offers spacious one and two-bedroom apartments that blend comfort with modern design. Picture your ideal home and get a glimpse of it from anywhere—take a virtual tour of our vibrant community and see your future oasis await!",
  "property_copyright": "2026 All Rights Reserved. Arctic Sun",
  "property_seo_title_home": "Arctic Sun |  Apartments in Anchorage, AK",
  "property_seo_description_home": "Experience life at Arctic Sun in Anchorage, AK. Choose from spacious one and two-bedroom apartments with modern amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Anchorage, AK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Arctic Sun in Anchorage, AK! Choose from stylish one and two-bedroom floor plans—your perfect home awaits.",
  "property_seo_title_amenities": "Amenities | Anchorage, AK Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Arctic Sun in Anchorage, AK. Enjoy spacious layouts, exceptional amenities, and a vibrant community. Feel at home today!",
  "property_seo_title_gallery": "Gallery | Apartments in Anchorage, AK",
  "property_seo_description_gallery": "Picture life at Arctic Sun in Anchorage, AK. Relish modern amenities, stunning views, and spacious layouts. Your comfort awaits in this vibrant community!",
  "property_seo_title_virtualtours": "Virtual Tours | Arctic Sun Apartments",
  "property_seo_description_virtualtours": "Experience Arctic Sun in Anchorage, AK! Take a virtual tour of our inviting one and two-bedroom apartments and envision your future home today.",
  "property_seo_title_interactivemap": "Interactive Map | Arctic Sun Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Arctic Sun in Anchorage, AK! Enjoy spacious layouts, modern amenities, and a welcoming community. Use our map to start your journey!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Anchorage, AK",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood of Arctic Sun in Anchorage, AK. Dive into local gems and explore nearby favorites that make our community truly special!",
  "property_seo_title_contact": "Contact Us | Arctic Sun",
  "property_seo_description_contact": "Connect with Arctic Sun in Anchorage, AK! Inquire about our One- and Two-Bedroom apartments. Your new home awaits—reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Find clarity at Arctic Sun in Anchorage! Our FAQ page answers your questions about our vibrant community, amenities & spacious floor plans. Get informed today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Uncover what our residents love about Arctic Sun in Anchorage! Enjoy spacious layouts, modern amenities, and a vibrant community atmosphere. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Find your ideal living space at Arctic Sun in Anchorage, AK! Enjoy spacious one & two-bedroom apartments with great amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Arctic Sun",
  "property_seo_description_residentaccess": "Login to Arctic Sun's resident portal—your go-to for paying rent, scheduling maintenance, and accessing community updates. Stay connected in Anchorage!",
  "property_seo_title_referafriend": "Refer A Friend | Arctic Sun",
  "property_seo_description_referafriend": "Share the joy of living at Arctic Sun! Refer a friend to our Anchorage community and enjoy great neighbors, exclusive perks, and vibrant living together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Arctic Sun",
  "property_seo_description_scheduletour": "Experience the warmth of Arctic Sun in Anchorage, AK! Schedule your tour today and step into your future home nestled in a vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | Arctic Sun",
  "property_seo_description_privacy": "At Arctic Sun in Anchorage, your privacy matters. Dive into our policy to see how we protect your information while you enjoy exceptional living experiences.",
  "property_seo_title_accessibility": "Website Accessibility | Arctic Sun",
  "property_seo_description_accessibility": "At Arctic Sun in Anchorage, AK, we prioritize digital inclusion and accessibility for all. Experience a welcoming community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Arctic Sun",
  "property_seo_description_sitemap": "Navigate the Arctic Sun community in Anchorage, AK with ease. Check our sitemap for a seamless living experience and discover every corner of your new home!",
  "property_seo_title_thankyou": "Thank You | Arctic Sun",
  "property_seo_description_thankyou": "Thank you for reaching out! A team member will be in touch soon to help you find your perfect home at Arctic Sun in beautiful Anchorage, AK. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793053844421",
  "amenities": [
    {
      "id": "ec_9a8cf5604fc3d362890e7e7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "126084076",
      "title": "Controlled Access Buildings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fc850235b9932a8423c75a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452621",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d35ee9b1c4f1e23c90aa7485",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452604",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_711e4bd339291c6df7a05495",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452605",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e6bd9514e1fbee0b419e5a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452606",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4dfde874cd42e15a1067b829",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452608",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19917dc0a75b5d37c6c55aaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "124799732",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c12f81339dc531dd4c425fd4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452622",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f7bd2522299ede5bda782a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452623",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60dcf9b4ac2d4a91edc43c84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452624",
      "title": "Large Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d9a32-e27c-7269-97d7-a8f2d9e5ccd1.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of a bedroom with a closet and a doorway leading to a hallway.",
        "public_id": "019d9a32-e27c-7269-97d7-a8f2d9e5ccd1",
        "storage_key": "property/6767906449167170/019d9a32-e27c-7269-97d7-a8f2d9e5ccd1.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Arctic Sun Apartments - Bedroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c594e923d23c35899f108041",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452625",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4903ee6ae20aeafad6d333b8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452626",
      "title": "Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fff75ab5a865e7916ec0237",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "external_id": "87452627",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ca02cfeeae5ae975d39f3712",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9083-76c9-b184-4c97e615a155.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and TV.",
        "public_id": "019d021b-9083-76c9-b184-4c97e615a155",
        "storage_key": "property/6767906449167170/019d021b-9083-76c9-b184-4c97e615a155.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, a stylish coffee table, and a mounted television, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with sectional sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (1).jpg"
    },
    {
      "id": "ec_7ba193e699ebb6be3e329332",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9066-7404-be00-d53865182d65.webp",
      "image_media": {
        "alt_text": "Kitchen with orange countertops and dark cabinets, featuring a stove and a dining area with a round table and four chairs.",
        "public_id": "019d021b-9066-7404-be00-d53865182d65",
        "storage_key": "property/6767906449167170/019d021b-9066-7404-be00-d53865182d65.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A spacious kitchen with ample counter space, a stove, and a dining nook perfect for meals. Dark cabinetry complements the vibrant orange countertops.",
      "link": "false",
      "alt_text": "Kitchen with orange countertops and dark cabinets, featuring a stove and a dining area with a round table and four chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (2).jpg"
    },
    {
      "id": "ec_de4287aad2d800d768de5ffa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-90a5-76ec-8550-26bf736945f7.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, two nightstands with lamps, and a dresser.",
        "public_id": "019d021b-90a5-76ec-8550-26bf736945f7",
        "storage_key": "property/6767906449167170/019d021b-90a5-76ec-8550-26bf736945f7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, featuring a comfortable queen-size bed, ample storage with a dresser, and stylish bedside tables.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, two nightstands with lamps, and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (3).png"
    },
    {
      "id": "ec_ad16407c799fc1b4cbe30c98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9066-7404-be00-d3d53ff0e8ff.webp",
      "image_media": {
        "alt_text": "Bathroom with a white bathtub, toilet, and vanity with a marble countertop.",
        "public_id": "019d021b-9066-7404-be00-d3d53ff0e8ff",
        "storage_key": "property/6767906449167170/019d021b-9066-7404-be00-d3d53ff0e8ff.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a white bathtub and toilet, complemented by a vanity with a marble-patterned countertop and wooden cabinets.",
      "link": "false",
      "alt_text": "Bathroom with a white bathtub, toilet, and vanity with a marble countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (4).jpg"
    },
    {
      "id": "ec_be174a10aa7eca2ae5011e22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9c62-739c-8abe-2f9cc450fded.webp",
      "image_media": {
        "alt_text": "Spacious living room with plush carpet and sliding glass doors leading to a balcony.",
        "public_id": "019d021b-9c62-739c-8abe-2f9cc450fded",
        "storage_key": "property/6767906449167170/019d021b-9c62-739c-8abe-2f9cc450fded.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the ample space in this living area, featuring soft carpeting and direct access to your private balcony.",
      "link": "false",
      "alt_text": "Spacious living room with plush carpet and sliding glass doors leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (5).jpg"
    },
    {
      "id": "ec_dc8603441bb633533d3e3ecd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9c52-7598-a286-61a13b40c154.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpet, large windows, and a sliding glass door leading to a balcony.",
        "public_id": "019d021b-9c52-7598-a286-61a13b40c154",
        "storage_key": "property/6767906449167170/019d021b-9c52-7598-a286-61a13b40c154.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy abundant natural light in this expansive living area. Features plush carpeting, large windows, and a private balcony accessible through a sliding glass door.",
      "link": "false",
      "alt_text": "Spacious living room with carpet, large windows, and a sliding glass door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (6).jpg"
    },
    {
      "id": "ec_3fc10d046f6519e299a8c7be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9c83-772c-907d-fe4dbfe0ad55.webp",
      "image_media": {
        "alt_text": "Spacious living room with plush carpet and a glimpse of the kitchen area.",
        "public_id": "019d021b-9c83-772c-907d-fe4dbfe0ad55",
        "storage_key": "property/6767906449167170/019d021b-9c83-772c-907d-fe4dbfe0ad55.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring neutral tones and soft carpeting, seamlessly flowing into the kitchen area. Perfect for comfortable everyday living.",
      "link": "false",
      "alt_text": "Spacious living room with plush carpet and a glimpse of the kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (7).jpg"
    },
    {
      "id": "ec_ce053e55bf1057263007cf1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-9e44-7548-84da-1b7a6379f1fa.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white refrigerator, stove, and sink.",
        "public_id": "019d021b-9e44-7548-84da-1b7a6379f1fa",
        "storage_key": "property/6767906449167170/019d021b-9e44-7548-84da-1b7a6379f1fa.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This apartment kitchen features dark wood cabinetry, a white refrigerator, a stove, and a double sink. A decorative bowl of green apples sits on the counter.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white refrigerator, stove, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (8).jpg"
    },
    {
      "id": "ec_242a3b8e5e7e6a87aebd503d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-ab0d-7569-8493-5a8f2dbd3399.webp",
      "image_media": {
        "alt_text": "Kitchen and living area view of an apartment.",
        "public_id": "019d021b-ab0d-7569-8493-5a8f2dbd3399",
        "storage_key": "property/6767906449167170/019d021b-ab0d-7569-8493-5a8f2dbd3399.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area adjacent to a kitchen with modern appliances and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen and living area view of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (9).jpg"
    },
    {
      "id": "ec_091d8b69cdb6b86583f15e8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-ad00-77c9-b46c-235ba43a08c0.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and view into hallway and bathroom.",
        "public_id": "019d021b-ad00-77c9-b46c-235ba43a08c0",
        "storage_key": "property/6767906449167170/019d021b-ad00-77c9-b46c-235ba43a08c0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a large closet with bi-fold doors, and a doorway leading to the bathroom and hallway.",
      "link": "false",
      "alt_text": "Bedroom with closet and view into hallway and bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (10).jpg"
    },
    {
      "id": "ec_55162b604768e51463258f94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-acbe-7114-a777-16376c310f2b.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and bathroom access",
        "public_id": "019d021b-acbe-7114-a777-16376c310f2b",
        "storage_key": "property/6767906449167170/019d021b-acbe-7114-a777-16376c310f2b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet and convenient access to a full bathroom, perfect for comfortable living.",
      "link": "false",
      "alt_text": "Bedroom with closet and bathroom access",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (11).jpg"
    },
    {
      "id": "ec_65ad018a6b59d865f81a795d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-af38-733b-9b8d-26b548565395.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, sink, and bathtub with shower curtain.",
        "public_id": "019d021b-af38-733b-9b8d-26b548565395",
        "storage_key": "property/6767906449167170/019d021b-af38-733b-9b8d-26b548565395.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Clean and functional bathroom featuring a toilet, vanity with sink, and a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, sink, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (12).jpg"
    },
    {
      "id": "ec_e6da928a4fe2a4a83302b219",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-ba19-759d-8a18-632d2c6e4e5f.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily property with red and beige siding and a large tree.",
        "public_id": "019d021b-ba19-759d-8a18-632d2c6e4e5f",
        "storage_key": "property/6767906449167170/019d021b-ba19-759d-8a18-632d2c6e4e5f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of the multifamily property showcasing its architecture, exterior siding, and landscaping. The building features a mix of red and beige siding, with multiple windows and balconies visible.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily property with red and beige siding and a large tree.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arctic-Sun_Favorites (13).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_05476589-2a6f-4fb3-9ab2-938da464de17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Jens' Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "701 W 36th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive Continental cooking served in an art-filled dining room & wine bar inside a strip mall.",
      "poi_long_description": "Inventive Continental cooking served in an art-filled dining room & wine bar inside a strip mall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-497f-76b9-bcf3-7612e47f1e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-497f-76b9-bcf3-7612e47f1e00",
        "storage_key": "property/6767906449167170/01a140c2-497f-76b9-bcf3-7612e47f1e00.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jensrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2371103546387498217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jens-restaurant",
      "poi_latitude": "61.1890855",
      "poi_longitude": "-149.8965651",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-561-5367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ90egSsKXyFYR6YQY4Bza5yA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_aa78df3a-4ee5-476b-a7f7-2685357f3094",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Jimmy's Asian Food Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "550 W Tudor Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Chinese restaurant serving authentic dishes and diverse sushi rolls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-3ef3-753a-85c3-6aa65f7a21e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-3ef3-753a-85c3-6aa65f7a21e7",
        "storage_key": "property/6767906449167170/01a140c2-3ef3-753a-85c3-6aa65f7a21e7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://anchorageasianfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14908680807555883812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jimmys-asian-food-restaurant",
      "poi_latitude": "61.1801434",
      "poi_longitude": "-149.8934414",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-646-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42dGlZOXyFYRJGMNdDRG5s4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_5ad69de4-45fe-489b-aa1f-61127bbcc69e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Serrano’s Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "525 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Vibrant Mexican restaurant serving scratch-made tacos, burritos, and handcrafted margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-3f5b-738d-8eb9-d3100d40bf9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-3f5b-738d-8eb9-d3100d40bf9a",
        "storage_key": "property/6767906449167170/01a140c2-3f5b-738d-8eb9-d3100d40bf9a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://serranosmexicangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10446076395002013008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "serranos-mexican-grill",
      "poi_latitude": "61.2186849",
      "poi_longitude": "-149.89254549999998",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-865-6898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdb9tbgC9yFYRUCWwtCLr95A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_1c5653aa-c4e9-4775-84f2-1f68462b137e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Dragon Seafood Restaurant & Grill",
      "poi_type": "Restaurants",
      "poi_address": "560 W Tudor Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Chinese buffet featuring Mongolian BBQ and a sushi selection.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-3eff-7508-83b7-fc3b63d1b0d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-3eff-7508-83b7-fc3b63d1b0d8",
        "storage_key": "property/6767906449167170/01a140c2-3eff-7508-83b7-fc3b63d1b0d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.dragonak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5990950466389974323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dragon-seafood-restaurant--grill",
      "poi_latitude": "61.18018",
      "poi_longitude": "-149.89381899999998",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-563-0087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDSjIF-uXyFYRM50iMLUhJFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_735427ee-057e-495c-a1a6-d482fc6b8f73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Guido's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "549 W International Airport Rd, Anchorage, AK 99518, USA",
      "poi_short_description": "Bright, simple venue offering pizza, traditional pasta dishes & Italian sandwiches, with delivery.",
      "poi_long_description": "Bright, simple venue offering pizza, traditional pasta dishes & Italian sandwiches, with delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4550-71d8-af52-3ec2d2a84531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4550-71d8-af52-3ec2d2a84531",
        "storage_key": "property/6767906449167170/01a140c2-4550-71d8-af52-3ec2d2a84531.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.guidospizza.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17956533684425410020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guidos-pizza",
      "poi_latitude": "61.17463",
      "poi_longitude": "-149.893939",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-563-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4HXVpeXyFYR5EWDiT9sMvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e74db97d-c542-4d15-b2bb-b10915176c7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Pho Gia Đình Vietnamese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "549 W International Airport Rd A1, Anchorage, AK 99518, USA",
      "poi_short_description": "Welcoming family-owned Vietnamese eatery serving authentic pho and flavorful bahn mi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4347-72e9-9a70-db722bec27ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4347-72e9-9a70-db722bec27ec",
        "storage_key": "property/6767906449167170/01a140c2-4347-72e9-9a70-db722bec27ec.webp",
        "width": 1280,
        "height": 797
      },
      "poi_business_url": "http://www.giadinhpho.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17463687173353696521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-gia-nh-vietnamese-restaurant",
      "poi_latitude": "61.1738978",
      "poi_longitude": "-149.8936778",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-222-2663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfX1fW-XyFYRCe1KJPV6W_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_bf010849-6d72-48b6-877b-7cab4fa1937d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Flight Deck Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "832 W International Airport Rd, Anchorage, AK 99518, USA",
      "poi_short_description": "Hometown pizza restaurant and dive bar serving hand-tossed pizza with karaoke and pool tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4294-75cc-a60a-b8a60b8ef561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4294-75cc-a60a-b8a60b8ef561",
        "storage_key": "property/6767906449167170/01a140c2-4294-75cc-a60a-b8a60b8ef561.webp",
        "width": 1280,
        "height": 810
      },
      "poi_business_url": "https://order.toasttab.com/online/flight-deck-pizzeria-832-w-intl-airport-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=16652812171072480837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flight-deck-pizzeria",
      "poi_latitude": "61.1732292",
      "poi_longitude": "-149.8992156",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-561-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3QxurJKXyFYRRaYTcHCsGuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_c3951459-54de-4fb2-8f49-3183176166ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Juno Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "109 W International Airport Rd, Anchorage, AK 99518, USA",
      "poi_short_description": "Convenient American hotel restaurant offering a breakfast buffet and casual dining options like burgers and salads.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-428d-706c-beec-9f8151d0c811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-428d-706c-beec-9f8151d0c811",
        "storage_key": "property/6767906449167170/01a140c2-428d-706c-beec-9f8151d0c811.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://juno.poi.place/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15390188664353222209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juno-restaurant",
      "poi_latitude": "61.174209299999994",
      "poi_longitude": "-149.88519119999998",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-433-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHweXmleXyFYRQW4ErQzvlNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_64dbc041-5948-491a-b3af-71aea27d7e74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Spenard Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1049 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_long_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-e474-7451-8cef-25e4bde4e391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-e474-7451-8cef-25e4bde4e391",
        "storage_key": "property/6767906449167170/019d021b-e474-7451-8cef-25e4bde4e391.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.spenardroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079478686688268729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-roadhouse",
      "poi_latitude": "61.19552819999999",
      "poi_longitude": "-149.9032167",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-770-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAGpNuXyFYRudEsUXaA4Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_786aa058-a425-4d38-bdc5-f9d5d9d94ad9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Kami Ramen | Japanese",
      "poi_type": "Restaurants",
      "poi_address": "3807 Spenard Rd, Anchorage, AK 99517, USA",
      "poi_short_description": "Popular Japanese ramen shop serving creamy tonkotsu and various traditional ramen bowls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4743-7797-b29c-e52f7207cfb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4743-7797-b29c-e52f7207cfb6",
        "storage_key": "property/6767906449167170/01a140c2-4743-7797-b29c-e52f7207cfb6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.kamiramen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16649381285391497054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kami-ramen--japanese",
      "poi_latitude": "61.18615169999999",
      "poi_longitude": "-149.91579919999998",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wT7DhWXyFYRXvfLHRF8Duc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_5f513606-5e2a-4ff7-81ae-9784d2e81466",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Ray's Place | Vietnamese Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "2412 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Casual, family-owned locale with familiar Vietnamese dishes to eat in or take out, plus beer & wine.",
      "poi_long_description": "Casual, family-owned locale with familiar Vietnamese dishes to eat in or take out, plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4601-74ae-9117-10e944976d40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4601-74ae-9117-10e944976d40",
        "storage_key": "property/6767906449167170/01a140c2-4601-74ae-9117-10e944976d40.webp",
        "width": 1280,
        "height": 1151
      },
      "poi_business_url": "http://www.raysplaceak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10244745762301632379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rays-place--vietnamese-cuisine",
      "poi_latitude": "61.19861139999999",
      "poi_longitude": "-149.9061646",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-279-2932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJecm6jNmXyFYRe18t6P2lLI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_57da9c6f-3428-4444-a14a-67aefbc7e7ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Lucky Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "5011 Arctic Blvd B, Anchorage, AK 99503, USA",
      "poi_short_description": "Casual restaurant offering Chinese and Filipino fare, including popular pork buns.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4bfa-7613-b4b3-3726d9f29224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4bfa-7613-b4b3-3726d9f29224",
        "storage_key": "property/6767906449167170/01a140c2-4bfa-7613-b4b3-3726d9f29224.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8852102327047954911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-kitchen",
      "poi_latitude": "61.1750936",
      "poi_longitude": "-149.8970901",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-929-2229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d4b-76bd-9c44-456bf79b7e9f",
        "storage_key": "property/6767906449167170/019d021c-4d4b-76bd-9c44-456bf79b7e9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSs30pKXyFYR3yEafyr82Ho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_fbd601f1-512d-4e93-84c1-5bffb1501840",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska House of Coffee",
      "poi_type": "Restaurants",
      "poi_address": "403 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Coffee shop serving a variety of lattes, mochas, and smoothies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4a49-776b-8c55-956a60b29775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4a49-776b-8c55-956a60b29775",
        "storage_key": "property/6767906449167170/01a140c2-4a49-776b-8c55-956a60b29775.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5363408122267568685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-house-of-coffee",
      "poi_latitude": "61.1954391",
      "poi_longitude": "-149.88964149999998",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-646-1288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d45-768c-80e1-d672c1e7c22b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d45-768c-80e1-d672c1e7c22b",
        "storage_key": "property/6767906449167170/019d021c-4d45-768c-80e1-d672c1e7c22b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJU-swLcWXyFYRLQo0SUWnbko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1dd5dc02-2eab-43cc-90ee-98f0ec614e28",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "SteamDot Coffee Benson Bar",
      "poi_type": "Restaurants",
      "poi_address": "600 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Chill coffeehouse offering house-roasted java & espresso drinks, plus baked goods.",
      "poi_long_description": "Chill coffeehouse offering house-roasted java & espresso drinks, plus baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4bf7-7408-af1d-5db4e211e65f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4bf7-7408-af1d-5db4e211e65f",
        "storage_key": "property/6767906449167170/01a140c2-4bf7-7408-af1d-5db4e211e65f.webp",
        "width": 1280,
        "height": 659
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15258980399264193462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steamdot-coffee-benson-bar",
      "poi_latitude": "61.1940043",
      "poi_longitude": "-149.8735771",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-278-2204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d45-768c-80e1-d672c1e7c22b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d45-768c-80e1-d672c1e7c22b",
        "storage_key": "property/6767906449167170/019d021c-4d45-768c-80e1-d672c1e7c22b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJPQMpFsiXyFYRtlvK3NPJwtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_a62c45c6-1571-46b8-b8fa-14197a4228d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Kaladi Brothers Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1340 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Coffeehouse chain offering hot & cold brews made with air-roasted beans in a hip space.",
      "poi_long_description": "Coffeehouse chain offering hot & cold brews made with air-roasted beans in a hip space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4d7f-73ad-ba2e-a65fff87adfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4d7f-73ad-ba2e-a65fff87adfa",
        "storage_key": "property/6767906449167170/01a140c2-4d7f-73ad-ba2e-a65fff87adfa.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://kaladi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14507406600490608444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaladi-brothers-coffee",
      "poi_latitude": "61.19457799999999",
      "poi_longitude": "-149.908459",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-644-7447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d45-768c-80e1-d672c1e7c22b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d45-768c-80e1-d672c1e7c22b",
        "storage_key": "property/6767906449167170/019d021c-4d45-768c-80e1-d672c1e7c22b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJscKQVtmXyFYRPGdminCpVMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_07b802a3-706c-4fed-b3a0-9a93f1aef7b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "2920 Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-51ea-716f-a527-5a4d9b20e02d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-51ea-716f-a527-5a4d9b20e02d",
        "storage_key": "property/6767906449167170/01a140c2-51ea-716f-a527-5a4d9b20e02d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/2920-seward-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8569521908080862281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.1938877",
      "poi_longitude": "-149.8713836",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-339-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5090-7729-be90-211240549333",
        "storage_key": "property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7Qa21CXyFYRSWQWqsUO7XY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1c4ea8f0-e44e-4da0-af89-62b0d4d6ee27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3101 A St, Anchorage, AK 99503, USA",
      "poi_short_description": "Comprehensive department store featuring a wide selection of groceries and general merchandise.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-f9ea-755d-b6d4-f1b8fe52aa2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-f9ea-755d-b6d4-f1b8fe52aa2c",
        "storage_key": "property/6767906449167170/019d021b-f9ea-755d-b6d4-f1b8fe52aa2c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2070-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4726814419269219339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.19226449999999",
      "poi_longitude": "-149.8802642",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-563-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-508e-7588-ab86-bd38bdde3c0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-508e-7588-ab86-bd38bdde3c0f",
        "storage_key": "property/6767906449167170/019d021c-508e-7588-ab86-bd38bdde3c0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOe6XNsaXyFYRC3S8q6sEmUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_260bd01d-db1f-439a-818e-4f061e02325e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "New Sagaya Midtown Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3700 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Asian-oriented grocery store featuring fresh seafood and a diverse selection of specialty international goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-4f8b-74bc-8231-fc01842de1bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-4f8b-74bc-8231-fc01842de1bb",
        "storage_key": "property/6767906449167170/01a140c2-4f8b-74bc-8231-fc01842de1bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://newsagaya.com/locations/midtown-market/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283561404102005412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-sagaya-midtown-market",
      "poi_latitude": "61.187121299999994",
      "poi_longitude": "-149.869869",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-561-5173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5090-7729-be90-211240549333",
        "storage_key": "property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaYHZrmXyFYRpNImWYaL2-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a96b1b68-1d90-457d-b06c-95ba51e1475f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 E Northern Lights Blvd, Anchorage, AK 99508, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021b-f726-7259-b52d-f4ccfe7e5839.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-f726-7259-b52d-f4ccfe7e5839",
        "storage_key": "property/6767906449167170/019d021b-f726-7259-b52d-f4ccfe7e5839.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/anchorage/701/00011?cid=loc_70100011_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8636677180229535916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.194478800000006",
      "poi_longitude": "-149.863708",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-264-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5090-7729-be90-211240549333",
        "storage_key": "property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9dGZ7aXyFYRrMhN5yKk23c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b74af673-039c-420d-b828-47c9b46eb09d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1470 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-522d-746d-bd49-5ae212ebf75b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-522d-746d-bd49-5ae212ebf75b",
        "storage_key": "property/6767906449167170/01a140c2-522d-746d-bd49-5ae212ebf75b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1470+w+northern+lights+blvd-anchorage-ak-99503/id=15092",
      "poi_directions_map_url": "https://maps.google.com/?cid=5983687261204770314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1946778",
      "poi_longitude": "-149.9120897",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-770-2503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbDasN6XyFYRCu4jc9xTClM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_a576cdc5-10d3-4d04-be32-0781e8e3aecf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "APA Asian Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 W 36th Ave #6, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-5220-71bc-8b28-2ecbaf5180a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-5220-71bc-8b28-2ecbaf5180a2",
        "storage_key": "property/6767906449167170/01a140c2-5220-71bc-8b28-2ecbaf5180a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=155077311586495607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apa-asian-market",
      "poi_latitude": "61.187563700000005",
      "poi_longitude": "-149.8876617",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-561-4460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5090-7729-be90-211240549333",
        "storage_key": "property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4sKJMGXyFYRd-zVRf7xJgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_0e3708fe-ab4f-49a3-abd0-b9a40d1536e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "The New Central Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "555 W Northern Lights Blvd #100, Anchorage, AK 99503, USA",
      "poi_short_description": "Asian grocery store offering a wide variety of Korean ingredients and fresh homemade side dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-5bdb-7480-ade9-8299643dcf32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-5bdb-7480-ade9-8299643dcf32",
        "storage_key": "property/6767906449167170/01a140c2-5bdb-7480-ade9-8299643dcf32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/New-Central-Market-727844017238133",
      "poi_directions_map_url": "https://maps.google.com/?cid=10831632745925458220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-new-central-market",
      "poi_latitude": "61.19576549999999",
      "poi_longitude": "-149.8943613",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-277-1170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5090-7729-be90-211240549333",
        "storage_key": "property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VNMOMWXyFYRLDlgDpiwUZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_3afaa6ab-3a45-4030-960e-059814218566",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "European Store and Deli",
      "poi_type": "Shopping & Retail",
      "poi_address": "601 W 36th Ave #12, Anchorage, AK 99503, USA",
      "poi_short_description": "Eastern European grocery store and deli offering imported specialty foods, deli meats, cheeses, and fresh baked goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-55b5-711d-ba82-b51339882dde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-55b5-711d-ba82-b51339882dde",
        "storage_key": "property/6767906449167170/01a140c2-55b5-711d-ba82-b51339882dde.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://europeandeliak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18179957052010106965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "european-store-and-deli",
      "poi_latitude": "61.1885857",
      "poi_longitude": "-149.8945724",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-561-3876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5090-7729-be90-211240549333",
        "storage_key": "property/6767906449167170/019d021c-5090-7729-be90-211240549333.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUMhz8OXyFYRVZDrBJ4uTPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0a791d00-3497-4a7a-a7f6-73141070558e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Title Wave Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "1360 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Locally-owned bookstore featuring a wide selection of new and used books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-56c8-751f-bf38-348369b6d642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-56c8-751f-bf38-348369b6d642",
        "storage_key": "property/6767906449167170/01a140c2-56c8-751f-bf38-348369b6d642.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wavebooks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14877852891255713295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "title-wave-books",
      "poi_latitude": "61.1945899",
      "poi_longitude": "-149.9093398",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-278-9283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-508e-7588-ab86-bd38bdde3c0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-508e-7588-ab86-bd38bdde3c0f",
        "storage_key": "property/6767906449167170/019d021c-508e-7588-ab86-bd38bdde3c0f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJscKQVtmXyFYRD67Q22DAeM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_273b341a-f5a0-4792-b8d1-3fe00d2b3384",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Willow Crest Elementary School",
      "poi_type": "Education",
      "poi_address": "1004 W Tudor Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/willowcrest",
      "poi_directions_map_url": "https://maps.google.com/?cid=2810682685606197606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-crest-elementary-school",
      "poi_latitude": "61.18010379999999",
      "poi_longitude": "-149.9035735",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJda6VA-yXyFYRZvnlywKNASc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_39ba7896-6976-4ae8-a698-08a81bae9b44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Romig Middle School",
      "poi_type": "Education",
      "poi_address": "2500 Minnesota Dr, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-573a-75d8-a96c-b04b81dcd556.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-573a-75d8-a96c-b04b81dcd556",
        "storage_key": "property/6767906449167170/01a140c2-573a-75d8-a96c-b04b81dcd556.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/romig",
      "poi_directions_map_url": "https://maps.google.com/?cid=8817967304801863302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "romig-middle-school",
      "poi_latitude": "61.1983852",
      "poi_longitude": "-149.91456820000002",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVzXvI9mXyFYRhka5S4u2X3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7fb67eb6-9a6b-4b0d-b0e7-fe7c782399dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "West Anchorage High School",
      "poi_type": "Education",
      "poi_address": "1700 Hillcrest Dr, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-5a63-77a8-a4f5-c6106b519346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-5a63-77a8-a4f5-c6106b519346",
        "storage_key": "property/6767906449167170/01a140c2-5a63-77a8-a4f5-c6106b519346.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://west.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15684090881757896505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-anchorage-high-school",
      "poi_latitude": "61.2007784",
      "poi_longitude": "-149.9166486",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-742-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeXfsf2K9yFYROV8fII8Vqdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d3bdcfd0-8dcd-4228-9de5-df54fe0b68e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Aquarian Charter School",
      "poi_type": "Education",
      "poi_address": "1705 W 32nd Ave, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-5c5c-762b-b9a2-d45b7d30fff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-5c5c-762b-b9a2-d45b7d30fff7",
        "storage_key": "property/6767906449167170/01a140c2-5c5c-762b-b9a2-d45b7d30fff7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/aquarian",
      "poi_directions_map_url": "https://maps.google.com/?cid=3952970424273298417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aquarian-charter-school",
      "poi_latitude": "61.192124699999994",
      "poi_longitude": "-149.91675999999998",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFZuGRt6XyFYR8WNvOqjF2zY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_56ba455c-6520-4646-aec4-0cc5522bf80b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "North Star Elementary School",
      "poi_type": "Education",
      "poi_address": "605 W Fireweed Ln, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-5ad6-708b-b100-388b9e9e4aac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-5ad6-708b-b100-388b9e9e4aac",
        "storage_key": "property/6767906449167170/01a140c2-5ad6-708b-b100-388b9e9e4aac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/northstar",
      "poi_directions_map_url": "https://maps.google.com/?cid=10574442937179307600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-star-elementary-school",
      "poi_latitude": "61.19960879999999",
      "poi_longitude": "-149.8942229",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC8iU0tGXyFYRUP41WNP3v5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e81a12d7-6313-4acf-82da-e9b3d74fd853",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Anchorage Montessori School",
      "poi_type": "Education",
      "poi_address": "5001 Northwood Dr, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.anchoragemontessorischool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15064255442461637784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-montessori-school",
      "poi_latitude": "61.17547279999999",
      "poi_longitude": "-149.92657219999998",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-276-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB8QsaPqXyFYRmLyr1YL8DtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_610071be-c848-42de-a481-4bd0d877a230",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Holy Rosary Academy",
      "poi_type": "Education",
      "poi_address": "1846 E 64th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-5fd4-71c8-90c9-744e89c895c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-5fd4-71c8-90c9-744e89c895c0",
        "storage_key": "property/6767906449167170/01a140c2-5fd4-71c8-90c9-744e89c895c0.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.hraak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3253552454997321548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-rosary-academy",
      "poi_latitude": "61.1618452",
      "poi_longitude": "-149.8482473",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-276-5822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGY3NDNqXyFYRTCc3QrjwJi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1c17e989-37f3-4be5-9d40-fc3bda2a08ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-06f5-72b3-926b-d3a3b2f870e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-06f5-72b3-926b-d3a3b2f870e7",
        "storage_key": "property/6767906449167170/019d021c-06f5-72b3-926b-d3a3b2f870e7.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.81955979999998",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cf3d0d68-1139-4dac-8e10-6ae2c5d4ecb7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Pacific University",
      "poi_type": "Education",
      "poi_address": "4101 University Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-0acc-74bf-9501-a09350ed8408.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-0acc-74bf-9501-a09350ed8408",
        "storage_key": "property/6767906449167170/019d021c-0acc-74bf-9501-a09350ed8408.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.alaskapacific.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603594146335186940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-pacific-university",
      "poi_latitude": "61.1892616",
      "poi_longitude": "-149.8065058",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-252-7528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsU8plvyWyFYR_F8cymU_CKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6d9eccdc-d965-4b89-9b35-842e98c08a02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Charter College",
      "poi_type": "Education",
      "poi_address": "2221 E Northern Lights Blvd #120, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-6106-701d-9948-328998ee72ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-6106-701d-9948-328998ee72ed",
        "storage_key": "property/6767906449167170/01a140c2-6106-701d-9948-328998ee72ed.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chartercollege.edu/locations/anchorage-ak?utm_source=google&utm_medium=google_my_business&utm_campaign=website_click",
      "poi_directions_map_url": "https://maps.google.com/?cid=10349624301214820613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charter-college",
      "poi_latitude": "61.19650629999999",
      "poi_longitude": "-149.8393264",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-277-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5163-7408-afb4-cbdc5616f749",
        "storage_key": "property/6767906449167170/019d021c-5163-7408-afb4-cbdc5616f749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ9OdTq2XyFYRBemooHdAoY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_b1d7c49b-e1e0-4948-87e5-6a22f769c63b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-4458-712c-9519-17c0b501fae3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-4458-712c-9519-17c0b501fae3",
        "storage_key": "property/6767906449167170/01a140c0-4458-712c-9519-17c0b501fae3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5412-76d5-9130-cc274574de6b",
        "storage_key": "property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bab5905d-9b7a-4045-9c82-bc92a19cc043",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-14de-73dc-b821-6c87cc52cac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-14de-73dc-b821-6c87cc52cac9",
        "storage_key": "property/6767906449167170/019d021c-14de-73dc-b821-6c87cc52cac9.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-8e93-7129-997b-dab8f60af7c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140c2-8e93-7129-997b-dab8f60af7c1",
        "storage_key": "property/6767906449167170/01a140c2-8e93-7129-997b-dab8f60af7c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_17cd921e-3617-4645-942d-21df24f8c978",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-635a-751c-ae75-708f2e29e3a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-635a-751c-ae75-708f2e29e3a1",
        "storage_key": "property/6767906449167170/01a140c2-635a-751c-ae75-708f2e29e3a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4d47-775b-aae6-46089542bdd5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-4d47-775b-aae6-46089542bdd5",
        "storage_key": "property/6767906449167170/019d021c-4d47-775b-aae6-46089542bdd5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ccb1cee0-5792-4cfc-b845-1ef6016e2ead",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-1deb-73ee-8d88-28778ebd764a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-1deb-73ee-8d88-28778ebd764a",
        "storage_key": "property/6767906449167170/019d021c-1deb-73ee-8d88-28778ebd764a.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5412-76d5-9130-cc274574de6b",
        "storage_key": "property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_865a243b-d324-4e70-a01f-a329b5710e46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-47f2-72c9-85cb-d473c8a4a3dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-47f2-72c9-85cb-d473c8a4a3dd",
        "storage_key": "property/6767906449167170/01a140c0-47f2-72c9-85cb-d473c8a4a3dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.97190659999998",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5412-76d5-9130-cc274574de6b",
        "storage_key": "property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_da2f70d5-647a-4ca5-a2c0-80385d17f2d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Putters Wild",
      "poi_type": "Entertainment",
      "poi_address": "1230 E 68th Ave #109, Anchorage, AK 99518, USA",
      "poi_short_description": "Blacklight mini golf played inside, plus trampoline basketball & an arcade with virtual reality.",
      "poi_long_description": "Blacklight mini golf played inside, plus trampoline basketball & an arcade with virtual reality.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-84fd-71a3-9d25-496a39890159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-84fd-71a3-9d25-496a39890159",
        "storage_key": "property/6767906449167170/01a140c2-84fd-71a3-9d25-496a39890159.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://putterswild.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6648922328819875089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "putters-wild",
      "poi_latitude": "61.158592000000006",
      "poi_longitude": "-149.858603",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-764-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM9qtA3mXyFYREb14bKG3RVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "custom_12407cd0-d0a3-408c-85a8-41c4acd0cc8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-4920-76f8-b348-97f762c1fc69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-4920-76f8-b348-97f762c1fc69",
        "storage_key": "property/6767906449167170/01a140c0-4920-76f8-b348-97f762c1fc69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-a614-71f6-89d9-aceb208d9ff1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140c0-a614-71f6-89d9-aceb208d9ff1",
        "storage_key": "property/6767906449167170/01a140c0-a614-71f6-89d9-aceb208d9ff1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_b7832c47-12c6-4061-ad0a-5da9420cdb5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Sullivan Arena",
      "poi_type": "Entertainment",
      "poi_address": "1600 Gambell St, Anchorage, AK 99501, USA",
      "poi_short_description": "Huge multi-use facility that hosts hockey & basketball games, rock concerts & trade shows.",
      "poi_long_description": "Huge multi-use facility that hosts hockey & basketball games, rock concerts & trade shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-5411-77a6-af38-bf39e159cb0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-5411-77a6-af38-bf39e159cb0a",
        "storage_key": "property/6767906449167170/01a140c0-5411-77a6-af38-bf39e159cb0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thesullivanarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523528862628190629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivan-arena",
      "poi_latitude": "61.20550159999999",
      "poi_longitude": "-149.8727135",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-868-4314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-a613-77f2-b6f1-25d8df0da50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140c0-a613-77f2-b6f1-25d8df0da50a",
        "storage_key": "property/6767906449167170/01a140c0-a613-77f2-b6f1-25d8df0da50a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAADyWyFYRpRmeDrryQwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_6093529f-f109-4709-ab7e-7bffcb87ed9b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "William A. Egan Civic & Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "555 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Downtown convention center offering flexible meeting space and traveler services including luggage storage and airport shuttles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-66e5-760b-ae14-d2d854f3b0b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-66e5-760b-ae14-d2d854f3b0b9",
        "storage_key": "property/6767906449167170/01a140c2-66e5-760b-ae14-d2d854f3b0b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2086414584322602747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-a-egan-civic--convention-center",
      "poi_latitude": "61.21773589999999",
      "poi_longitude": "-149.8916534",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-263-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-a613-77f2-b6f1-25d8df0da50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140c0-a613-77f2-b6f1-25d8df0da50a",
        "storage_key": "property/6767906449167170/01a140c0-a613-77f2-b6f1-25d8df0da50a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaMkCiqWyFYR-za-mAJv9Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_26f6ad1a-ba5d-4458-b6eb-826b7db25d11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Oscar Anderson House Museum",
      "poi_type": "Entertainment",
      "poi_address": "420 M St, Anchorage, AK 99501, USA",
      "poi_short_description": "Built in 1915, this home is filled with antiques & serves as a monument to early Anchorage life.",
      "poi_long_description": "Built in 1915, this home is filled with antiques & serves as a monument to early Anchorage life.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-65c9-7508-bbca-d6fd5aa82c21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-65c9-7508-bbca-d6fd5aa82c21",
        "storage_key": "property/6767906449167170/01a140c2-65c9-7508-bbca-d6fd5aa82c21.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.oscarandersonhousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=128384008720912302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oscar-anderson-house-museum",
      "poi_latitude": "61.21856469999999",
      "poi_longitude": "-149.9060092",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-206-2284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5412-76d5-9130-cc274574de6b",
        "storage_key": "property/6767906449167170/019d021c-5412-76d5-9130-cc274574de6b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvy0C74O9yFYRro-mYpMcyAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4f50ab27-9f31-4b80-bc0c-58ef0dcab3b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-5e35-701a-ac8d-6161339878f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-5e35-701a-ac8d-6161339878f0",
        "storage_key": "property/6767906449167170/01a140c0-5e35-701a-ac8d-6161339878f0.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.82213539999998",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-542b-75bf-aa81-ebb7b9239590",
        "storage_key": "property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_7c527697-10fd-4682-a0c4-400d432213c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4263-73de-b89d-63d21f953d9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-4263-73de-b89d-63d21f953d9d",
        "storage_key": "property/6767906449167170/019d021c-4263-73de-b89d-63d21f953d9d.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.80024269999998",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-542b-75bf-aa81-ebb7b9239590",
        "storage_key": "property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_20b1f754-ed45-4239-8d18-e211e214336e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Providence Urgent Care - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 W Northern Lights Blvd B, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-66d8-7708-9562-aaa649621f04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-66d8-7708-9562-aaa649621f04",
        "storage_key": "property/6767906449167170/01a140c2-66d8-7708-9562-aaa649621f04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/ak/urgent-care-midtown?Is=location&y_source=1_MzAxNTI2NzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16999347318438363632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-urgent-care---midtown",
      "poi_latitude": "61.1952149",
      "poi_longitude": "-149.9066709",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-212-5165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL90jWz6XyFYR8AEC2VHQ6es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6e09db5b-aee7-48d9-a901-b6b6717e1e77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "AMS Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "3401 Minnesota Dr #100, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-69f6-76dd-a239-b361ecc2317b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-69f6-76dd-a239-b361ecc2317b",
        "storage_key": "property/6767906449167170/01a140c2-69f6-76dd-a239-b361ecc2317b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://amsurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805240541233911751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ams-urgent-care",
      "poi_latitude": "61.1891074",
      "poi_longitude": "-149.91239919999998",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-677-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwZ1h92XyFYRx5etW21atbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_901825a2-c2a7-4cdf-8b69-3b7feeb5b62a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3101 A St, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-27b6-769c-b0fd-0caa509ee825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-27b6-769c-b0fd-0caa509ee825",
        "storage_key": "property/6767906449167170/019d021c-27b6-769c-b0fd-0caa509ee825.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/2070-anchorage-ak/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17123885227622138721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "61.1923057",
      "poi_longitude": "-149.8791033",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-563-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5559-749d-8a03-e86c968f8974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5559-749d-8a03-e86c968f8974",
        "storage_key": "property/6767906449167170/019d021c-5559-749d-8a03-e86c968f8974.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe6XNsaXyFYRYQP6ZuNCpO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6fb12f92-685e-4b20-9fb1-95e822044947",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Anchorage Neighborhood Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4951 Business Park Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-6ca5-74cb-aba5-005a0a27dff8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-6ca5-74cb-aba5-005a0a27dff8",
        "storage_key": "property/6767906449167170/01a140c2-6ca5-74cb-aba5-005a0a27dff8.webp",
        "width": 1280,
        "height": 561
      },
      "poi_business_url": "https://www.anhc.org/hours-and-location",
      "poi_directions_map_url": "https://maps.google.com/?cid=17288056033304741550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-neighborhood-health-center",
      "poi_latitude": "61.1759686",
      "poi_longitude": "-149.88766339999998",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-743-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfDgyDCWyFYRroYtwl2D6-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_e9164dac-7241-44d5-8f35-267826bab762",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 A St, Anchorage, AK 99503, USA",
      "poi_short_description": "24/7 fitness center featuring diverse workout equipment and group training classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-29bb-71e7-a346-54a7c863378d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-29bb-71e7-a346-54a7c863378d",
        "storage_key": "property/6767906449167170/019d021c-29bb-71e7-a346-54a7c863378d.webp",
        "width": 540,
        "height": 405
      },
      "poi_business_url": "https://alaskafitness.net/?utm_source=omg-gbp&utm_medium=webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=9562682542507911640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-fitness",
      "poi_latitude": "61.195833099999994",
      "poi_longitude": "-149.88410779999998",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-646-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-8e93-7129-997b-dab8f60af7c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140c2-8e93-7129-997b-dab8f60af7c1",
        "storage_key": "property/6767906449167170/01a140c2-8e93-7129-997b-dab8f60af7c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxqTXM-XyFYR2GkDbht5tYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_609e5205-2aee-475d-a593-3d9cfd8fe74a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Anchorage Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "701 W 36th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Welcoming yoga studio offering a variety of classes and hot yoga sessions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-646e-75c2-8341-d3ada8165f7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-646e-75c2-8341-d3ada8165f7d",
        "storage_key": "property/6767906449167170/01a140c0-646e-75c2-8341-d3ada8165f7d.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "http://anchorageyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1189873777368163935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-yoga",
      "poi_latitude": "61.188709200000005",
      "poi_longitude": "-149.89640939999998",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-562-9642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ90egSsKXyFYRX-aUc-VHgxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_0640412b-64f0-48ad-9ac5-46efbbee481e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Rock Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "665 E 33rd Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Indoor rock climbing gym offering programs for adults & kids, plus fitness classes.",
      "poi_long_description": "Indoor rock climbing gym offering programs for adults & kids, plus fitness classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-70a6-717a-b0f3-acafb57e9b8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-70a6-717a-b0f3-acafb57e9b8d",
        "storage_key": "property/6767906449167170/01a140c2-70a6-717a-b0f3-acafb57e9b8d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.alaskarockgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15802851744102552212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-rock-gym",
      "poi_latitude": "61.191290300000006",
      "poi_longitude": "-149.8710874",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-562-7265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-a613-77f2-b6f1-25d8df0da50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140c0-a613-77f2-b6f1-25d8df0da50a",
        "storage_key": "property/6767906449167170/01a140c0-a613-77f2-b6f1-25d8df0da50a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1_7o5eXyFYRlBJlJe8BT9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_51db4ff9-ee76-4faa-b9e1-449d0aa649a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Cuddy Family Midtown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E 40th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Park with a colorful playground, exercise track, pond, a small amphitheater & seasonal ice skating.",
      "poi_long_description": "Park with a colorful playground, exercise track, pond, a small amphitheater & seasonal ice skating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-30b9-7442-85a2-caafb3931bed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-30b9-7442-85a2-caafb3931bed",
        "storage_key": "property/6767906449167170/019d021c-30b9-7442-85a2-caafb3931bed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.org/detail/cuddy-family-midtown-park#photos",
      "poi_directions_map_url": "https://maps.google.com/?cid=4525791115162483285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cuddy-family-midtown-park",
      "poi_latitude": "61.18422299999999",
      "poi_longitude": "-149.880937",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-555a-7169-b523-f4a3ac2ba753",
        "storage_key": "property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8sKob-XyFYRVfrgYgrXzj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_140fe350-7a84-4f6f-a99e-71b00c11e78b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Pop Carr Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hampshire Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Quiet city park featuring tennis courts and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-6fd7-773e-b671-9decaf5f6b6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-6fd7-773e-b671-9decaf5f6b6b",
        "storage_key": "property/6767906449167170/01a140c2-6fd7-773e-b671-9decaf5f6b6b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13678918657624959400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pop-carr-memorial-park",
      "poi_latitude": "61.1790321",
      "poi_longitude": "-149.9008818",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-555a-7169-b523-f4a3ac2ba753",
        "storage_key": "property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38sZjOuXyFYRqOkyiwtI1b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d60a50b1-c4b7-42bd-9831-c65e00e15b88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Red Bridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2205 W 45th Ave, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-710c-769a-b548-8565dd3d2185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-710c-769a-b548-8565dd3d2185",
        "storage_key": "property/6767906449167170/01a140c2-710c-769a-b548-8565dd3d2185.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11619710780464110487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-bridge-park",
      "poi_latitude": "61.1799243",
      "poi_longitude": "-149.9249878",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-555a-7169-b523-f4a3ac2ba753",
        "storage_key": "property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE6iC0OSXyFYRlxtXFmSBQaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0126441a-797e-47e4-817a-b24604b4cbf6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Wilson Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3955 Wilson St, Anchorage, AK 99503, USA",
      "poi_short_description": "Outdoor area featuring a playground for kids as well as picnic tables and grassy spaces for relaxation.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-77b0-7123-b2f9-e861bbff6928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-77b0-7123-b2f9-e861bbff6928",
        "storage_key": "property/6767906449167170/01a140c2-77b0-7123-b2f9-e861bbff6928.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10275963236105015610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilson-street-park",
      "poi_latitude": "61.184468599999995",
      "poi_longitude": "-149.905957",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-555a-7169-b523-f4a3ac2ba753",
        "storage_key": "property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe9IWUOiXyFYROlEDbR6Om44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c93a6644-c406-460c-93df-b96744b04015",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Margaret Eagan Sullivan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1824 W 15th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_long_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-75c1-70c9-b150-6e0170b17dff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-75c1-70c9-b150-6e0170b17dff",
        "storage_key": "property/6767906449167170/01a140c2-75c1-70c9-b150-6e0170b17dff.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10765612440412588611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "margaret-eagan-sullivan-park",
      "poi_latitude": "61.20760069999999",
      "poi_longitude": "-149.91709509999998",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-555a-7169-b523-f4a3ac2ba753",
        "storage_key": "property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwm4bXy9yFYRQ4pR1HkjZ5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_e11f81f7-24c2-488c-8c2b-ce2bef1eeaca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Kincaid Outdoor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-75a1-74cf-8a53-34e1b8b1cfdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-75a1-74cf-8a53-34e1b8b1cfdf",
        "storage_key": "property/6767906449167170/01a140c2-75a1-74cf-8a53-34e1b8b1cfdf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4482038648302601019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-outdoor-center",
      "poi_latitude": "61.154224199999994",
      "poi_longitude": "-150.0565216",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0U0ufCiyFYROwOmXWdmMz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "picnic_ground"
    },
    {
      "id": "custom_2670341d-c23f-4f57-a495-fe0e0f8b8a60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Point Woronzof Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9700 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_long_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-baf0-75ed-9c04-6ee190d3386f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-baf0-75ed-9c04-6ee190d3386f",
        "storage_key": "property/6767906449167170/019d021c-baf0-75ed-9c04-6ee190d3386f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3646899879165127207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "point-woronzof-park",
      "poi_latitude": "61.201123599999995",
      "poi_longitude": "-150.0203185",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-555a-7169-b523-f4a3ac2ba753",
        "storage_key": "property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7F3TS29yFYRJ2oNNR5knDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_4effdad5-eab9-4642-a675-2dadd4c38ff6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Earthquake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5101 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_long_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-6407-7403-85f8-2add1d40aa05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-6407-7403-85f8-2add1d40aa05",
        "storage_key": "property/6767906449167170/01a140c0-6407-7403-85f8-2add1d40aa05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.anchorage.net/discover/trails-and-local-parks/earthquake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10919572690925706311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earthquake-park",
      "poi_latitude": "61.1984068",
      "poi_longitude": "-149.98020839999998",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-555a-7169-b523-f4a3ac2ba753",
        "storage_key": "property/6767906449167170/019d021c-555a-7169-b523-f4a3ac2ba753.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2AwokC9yFYRR9yuDYIdipc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_58159487-437a-4af1-b34c-7378f19dd96a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Spenard Community Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 W 48th Ave, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-79a2-75ee-9045-85b66243e356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-79a2-75ee-9045-85b66243e356",
        "storage_key": "property/6767906449167170/01a140c2-79a2-75ee-9045-85b66243e356.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Spenard.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11786923528780205705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-community-recreation-center",
      "poi_latitude": "61.176693199999995",
      "poi_longitude": "-149.92097529999998",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQvgCvCXyFYRiU6j53-Qk6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_3e637a9f-1e8e-4d46-8583-3d944acdb564",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Lake Hood Seaplane Base",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99530, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-703b-7474-a212-1b1dbc88a855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-703b-7474-a212-1b1dbc88a855",
        "storage_key": "property/6767906449167170/01a140c0-703b-7474-a212-1b1dbc88a855.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5592799726301707418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hood-seaplane-base",
      "poi_latitude": "61.181679800000005",
      "poi_longitude": "-149.9745572",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5886-74fa-a4ed-c88b2febf82c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5886-74fa-a4ed-c88b2febf82c",
        "storage_key": "property/6767906449167170/019d021c-5886-74fa-a4ed-c88b2febf82c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7z6jb029yFYRmnwdGridnU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_dd652da6-1447-4a92-ad43-4b292d2c275a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-7e46-77c2-8fb1-c761060871f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-7e46-77c2-8fb1-c761060871f6",
        "storage_key": "property/6767906449167170/01a140c2-7e46-77c2-8fb1-c761060871f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_78323dc5-ad24-40af-aec1-3e4d78408d53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-7f67-720d-9892-03c5bc937b93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-7f67-720d-9892-03c5bc937b93",
        "storage_key": "property/6767906449167170/01a140c2-7f67-720d-9892-03c5bc937b93.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-8ea4-769c-b418-a4406ed38866.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140c2-8ea4-769c-b418-a4406ed38866",
        "storage_key": "property/6767906449167170/01a140c2-8ea4-769c-b418-a4406ed38866.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1eab432d-ae94-4842-babd-547d231aadce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Central Transfer Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1208 E 56th Ave, Anchorage, AK 99518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-7feb-7267-8b7b-fa2b921117a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-7feb-7267-8b7b-fa2b921117a6",
        "storage_key": "property/6767906449167170/01a140c2-7feb-7267-8b7b-fa2b921117a6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/SWS/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11377918452066376081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-transfer-station",
      "poi_latitude": "61.168456199999994",
      "poi_longitude": "-149.8603621",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-6250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36RUMnqXyFYRkVnHoox85p0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_38f788aa-1859-448a-abd5-2cacbc8ccb47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-6bdf-7544-8da6-82a8c13ed061.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-6bdf-7544-8da6-82a8c13ed061",
        "storage_key": "property/6767906449167170/01a140c0-6bdf-7544-8da6-82a8c13ed061.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.2216964",
      "poi_longitude": "-149.8901898",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5883-747c-a68c-820c4b1de026.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5883-747c-a68c-820c4b1de026",
        "storage_key": "property/6767906449167170/019d021c-5883-747c-a68c-820c4b1de026.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_0e765589-5762-430e-8dff-598bfafa4ae1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-66ba-7479-b873-a60866682c6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-66ba-7479-b873-a60866682c6f",
        "storage_key": "property/6767906449167170/01a140c0-66ba-7479-b873-a60866682c6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-5886-74fa-a4ed-c88b2febf82c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-5886-74fa-a4ed-c88b2febf82c",
        "storage_key": "property/6767906449167170/019d021c-5886-74fa-a4ed-c88b2febf82c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_176252bd-e411-4543-a93e-8cafd20ef074",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-4414-77a1-a05a-42ab78bc0625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-4414-77a1-a05a-42ab78bc0625",
        "storage_key": "property/6767906449167170/019d021c-4414-77a1-a05a-42ab78bc0625.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.184003999999995",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-542b-75bf-aa81-ebb7b9239590",
        "storage_key": "property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_c3c8ff24-a654-48fe-9d92-95693096c72e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Southcentral Foundation Nu ch’ghednu Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Southcentral Foundation Administration Building, 4501 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-8496-717c-b7a1-19552a2647d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-8496-717c-b7a1-19552a2647d9",
        "storage_key": "property/6767906449167170/01a140c2-8496-717c-b7a1-19552a2647d9.webp",
        "width": 1022,
        "height": 1280
      },
      "poi_business_url": "https://www.southcentralfoundation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17022574653971337258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southcentral-foundation-nu-chghednu-building",
      "poi_latitude": "61.18234169999999",
      "poi_longitude": "-149.79589199999998",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-729-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYTXMhyXyFYRKpCHVHVVPOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a2fa1c55-535e-4e38-aaa9-7578804c30ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-20d4-75fe-b3a0-e0475280b667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-20d4-75fe-b3a0-e0475280b667",
        "storage_key": "property/6767906449167170/019d021c-20d4-75fe-b3a0-e0475280b667.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2107038",
      "poi_longitude": "-149.8288584",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-542b-75bf-aa81-ebb7b9239590",
        "storage_key": "property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a62dfab4-31ca-4036-ad7d-9e4f0b207ef8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Anchorage VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-860a-73d9-9864-bc3f985d0668.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-860a-73d9-9864-bc3f985d0668",
        "storage_key": "property/6767906449167170/01a140c2-860a-73d9-9864-bc3f985d0668.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.va.gov/locations/directions.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1810043390262328329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-va-medical-center",
      "poi_latitude": "61.23270319999999",
      "poi_longitude": "-149.7444828",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-353-7574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-542b-75bf-aa81-ebb7b9239590",
        "storage_key": "property/6767906449167170/019d021c-542b-75bf-aa81-ebb7b9239590.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYzvJi-UyFYRCTyhmN-QHhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9638b4eb-99fd-474b-be53-50e77a5e9f50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c0-70d8-776f-aa07-a882a389e4b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c0-70d8-776f-aa07-a882a389e4b7",
        "storage_key": "property/6767906449167170/01a140c0-70d8-776f-aa07-a882a389e4b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.216329900000005",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-59d9-727a-ad2f-d18ec5a47ba9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-59d9-727a-ad2f-d18ec5a47ba9",
        "storage_key": "property/6767906449167170/019d021c-59d9-727a-ad2f-d18ec5a47ba9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_47dc833b-c591-4744-985d-b5c21c924638",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "custom",
      "poi_name": "Hilcorp Alaska",
      "poi_type": "Major Employers & Offices",
      "poi_address": "JL Tower, 3800 Centerpoint Dr #1400, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/01a140c2-8964-770e-b124-6a7865b54682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140c2-8964-770e-b124-6a7865b54682",
        "storage_key": "property/6767906449167170/01a140c2-8964-770e-b124-6a7865b54682.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hilcorp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1231158791914635008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilcorp-alaska",
      "poi_latitude": "61.18589769999999",
      "poi_longitude": "-149.89156440000002",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-777-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-516a-766c-b014-5de28cd23f55",
        "storage_key": "property/6767906449167170/019d021c-516a-766c-b014-5de28cd23f55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERJxtsGXyFYRAL8r9mX0FRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_0b7ac310c5150dae5d16fb92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9eb8d132e3d7ec9c538c1de4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1fb727fc06702addb3e2be65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1f8468ce4983deeab7fa074a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_81113d2862139ddb57a07ac7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_abceb23c28b0e26159b3a4f6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "rating": "5",
      "name": "Steven Gardner",
      "text": "I used to live here for about 4ish years, and I have to say that this was one of the best places I've lived ever. In addition my property manager Charity is an Allstar, she helped me and mine with advice and guidance in times when things seemed hopeless. Charity is like a mother to all of her tenants and treats everyone fairly and with gracious respect.  I will always recommend this property to live in to both single people and families that are just starting out. If you see this Charity I'll miss you so much and cherish having been a tenant of yours :)",
      "date": "2023-04-06",
      "title": "false"
    },
    {
      "id": "ec_a85840a01dc4dd52bc26fed1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "rating": "5",
      "name": "ferchu waddoups",
      "text": "My apartment is wonderful; it receives plenty of sunlight, has spacious interiors, and shares only one wall with neighboring units. All appliances are in excellent condition, and whenever I had an issue with the dishwasher, it was promptly replaced with a new one. I am grateful for the manager and maintenance staff who are always quick to resolve any concerns or problems. Additionally, the location is superb as it is situated right in the center of Anchorage. Ahh and of course a super plus that the apartment allows both dogs and cats.",
      "date": "2023-04-26",
      "title": "false"
    },
    {
      "id": "ec_d815f31bb4abe6f95ef36a25",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "rating": "5",
      "name": "Lindsey Mumme",
      "text": "The environment is amazing. Everybody knows everybody here. Everyone is super nice. The property manager (Charity Medlin) is fantastic and kind! She's very understanding, and takes care of anything you need right away. She's even organized Christmas gifts for residents before. I know I'll never have to worry about any problems while I'm at this property, and that makes me want to stay for a good long while :)",
      "date": "2021-07-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_c6d9af82962782683a493c04",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019ddcf7-fbc6-72ad-b1c4-ba215f79dc49.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-fbc6-72ad-b1c4-ba215f79dc49",
        "storage_key": "property/6767906449167170/019ddcf7-fbc6-72ad-b1c4-ba215f79dc49.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x1 1100a",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Es2WznjRbKf"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d699-701b-9877-7d042f322f59",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Arctic Sun Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "generator",
      "page_item_url": "midtown-anchorage-apartments-walk-in-closets",
      "search_query": "apartments with large walk-in closets in Midtown Anchorage",
      "category": "Amenity",
      "h1_title": "Spacious Walk-In Closets in Midtown Anchorage",
      "h2_subtitle": "Discover apartments with large walk-in closets in Midtown Anchorage. Live comfortably at Arctic Sun and enjoy our premium amenities.",
      "page_copy": "Experience the luxury of Arctic Sun apartment living in Midtown Anchorage, where spacious walk-in closets are just the beginning. Our apartments offer a serene living environment with views that capture the essence of Anchorage. Residents appreciate our smoke-free community, ensuring fresh air and cleanliness throughout.\n\nArctic Sun provides modern conveniences such as online payment and service requests, and the perk of 24-hour access, allowing tenants to tailor their lifestyle according to their needs. With the unique addition of skylights and other amenities, you'll find that living in an apartment with large walk-in closets in Midtown Anchorage is only one of the many benefits awaiting you at Arctic Sun.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Anchorage Apartments - Large Walk-In Closets",
      "seo_description": "Explore Arctic Sun's Midtown Anchorage apartments featuring large walk-in closets and modern amenities. Live comfortably in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "generator",
      "page_item_url": "anchorage-ak-smoke-free-apartments",
      "search_query": "smoke-free apartments Anchorage AK",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Anchorage, AK",
      "h2_subtitle": "Discover smoke-free living in Anchorage, AK. Arctic Sun offers a clean and healthy environment with premium amenities.",
      "page_copy": "Welcome to Arctic Sun, where smoke-free living in Anchorage, AK, is redefined. Our community prioritizes health and comfort, providing you with a fresh and clean atmosphere. Set in the desirable Midtown neighborhood, Arctic Sun allows you to enjoy quintessential prairie views and modern conveniences.\n\nEmbrace a suite of amenities such as skylights that brighten your home, and the ease of online payments and service requests. Our 24-hour access feature ensures you have flexibility and freedom. At Arctic Sun, living in smoke-free apartments in Anchorage, AK, means prioritizing both comfort and quality of life, in a location that puts you close to the best the city has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Anchorage, AK Smoke-Free Apartments",
      "seo_description": "Live smoke-free at Arctic Sun in Anchorage, AK. Enjoy a healthy lifestyle with modern amenities in a beautiful Midtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "generator",
      "page_item_url": "99503-apartments-patios-balconies",
      "search_query": "apartments with patios and balconies in 99503",
      "category": "Amenity",
      "h1_title": "Patios and Balconies in 99503 Apartments",
      "h2_subtitle": "Explore apartments with patios and balconies in the 99503 area. Enjoy outdoor living at Arctic Sun in Midtown Anchorage.",
      "page_copy": "At Arctic Sun, located in the heart of Anchorage’s 99503 region, experience living in apartments featuring patios and balconies designed for relaxation and enjoyment. These outdoor spaces are perfect for taking in the striking views that our location provides, adding an exceptional outdoor dimension to your home.\n\nBesides expansive views, our residents benefit from numerous modern amenities, including the convenience of online payments and service requests, plus the peace of a smoke-free environment. With 24-hour access, Arctic Sun makes it easy for you to settle into the rhythm of life in Midtown Anchorage while enjoying the tranquility and space provided by patios and balconies.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "99503 Apartments with Patios and Balconies",
      "seo_description": "Discover Arctic Sun's apartments in the 99503 area featuring patios and balconies. Enjoy outdoor living with modern amenities in Midtown Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "generator",
      "page_item_url": "anchorage-on-site-laundry-apartments",
      "search_query": "Anchorage apartments with on-site laundry facilities",
      "category": "Amenity",
      "h1_title": "Anchorage Apartments with On-Site Laundry",
      "h2_subtitle": "Experience convenience in Anchorage with apartments offering on-site laundry facilities. Arctic Sun combines comfort with accessibility.",
      "page_copy": "Arctic Sun offers you the convenience of Anchorage apartments equipped with on-site laundry facilities, ensuring that your day-to-day chores are as stress-free as possible. Located in the bustling Midtown area, our community provides an ideal living environment combining practicality with style.\n\nAside from on-site laundry, Arctic Sun boasts numerous amenities, such as smoke-free living, picturesque views, and skylights that fill your home with natural light. With online payment and service request systems, managing your apartment is simple and efficient. Discover how Arctic Sun enhances your lifestyle with the blend of convenience and comfort you deserve in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Anchorage Apartments - On-Site Laundry",
      "seo_description": "Choose Arctic Sun in Anchorage for apartments with on-site laundry facilities. Enjoy modern amenities in a prime Midtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "generator",
      "page_item_url": "anchorage-municipality-gated-community",
      "search_query": "gated community apartments in Anchorage Municipality",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Anchorage",
      "h2_subtitle": "Discover gated community living in the Anchorage Municipality at Arctic Sun. Enjoy security and privacy with modern amenities.",
      "page_copy": "Arctic Sun brings you the benefits of living in a gated community within Anchorage Municipality. Our community combines the peace of mind that a secure environment provides, with the elegance of modern living. Nestled in Midtown Anchorage, Arctic Sun offers the perfect blend of accessibility and privacy.\n\nIn addition to the security of a gated community, you'll enjoy a smoke-free environment, wonderful views, and skylights that allow natural light to fill your space. With options such as online payments and service requests, living at Arctic Sun ensures both convenience and a premium lifestyle experience in Anchorage Municipality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Anchorage Gated Community Apartments",
      "seo_description": "Live securely at Arctic Sun, a gated community in Anchorage Municipality. Enjoy modern amenities and privacy in a top-tier Midtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "generator",
      "page_item_url": "two-bedroom-midtown-anchorage-apartments",
      "search_query": "two bedroom apartments midtown anchorage",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Midtown Anchorage",
      "h2_subtitle": "Find spacious two bedroom apartments in Midtown Anchorage at Arctic Sun. Ideal living spaces with modern amenities await you.",
      "page_copy": "At Arctic Sun, discover expansive two bedroom apartments in the heart of Midtown Anchorage. Our thoughtfully designed spaces provide residents with both comfort and functionality, making it the perfect setting for those looking to enjoy all that Anchorage has to offer.\n\nEach apartment features ample room and modern amenities, including online payment options and service request capabilities. Enjoy the tranquility of a smoke-free environment, stunning views, and an abundance of natural light through skylights. Arctic Sun is dedicated to offering a premium living experience in Midtown, combining convenience with an ideal location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious 2 Bedroom Apartments in Midtown Anchorage",
      "seo_description": "Explore Arctic Sun's two bedroom apartments in Midtown Anchorage. Enjoy modern amenities in a prime location with views and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167170",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-99503",
      "search_query": "one bedroom apartments 99503",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in 99503",
      "h2_subtitle": "Discover modern and cozy one bedroom apartments at Arctic Sun, located in the vibrant 99503 area of Anchorage.",
      "page_copy": "Arctic Sun offers charming one bedroom apartments conveniently located in the heart of the 99503 area. Our community provides the ideal setting for singles or couples looking to enjoy all the amenities of city living while maintaining a cozy and welcoming home.\n\nThese apartments boast features such as smoke-free environments, picturesque views, and unique skylights that allow plenty of natural light. With online payment systems and timely service requests, you'll find living at Arctic Sun stress-free and enjoyable. Experience the comforts of modern living and the convenience of being in one of Anchorage's sought-after locations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern One Bedroom Apartments in Anchorage 99503",
      "seo_description": "Explore Arctic Sun’s cozy one bedroom apartments in 99503. Enjoy modern amenities with a prime Midtown Anchorage location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309351611"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085019"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "5b7e0fcf-9fb1-4800-9fec-064f41d7cfa6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/dffd43ab-40b4-4630-b448-0b4019bfc9d1/app.js?property=dffd43ab-40b4-4630-b448-0b4019bfc9d1&propertyName=Arctic+Sun&channelUuid=c248fbdb-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47676658716"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBGWFNENGVwcWdOT2I2TThoYkxyNWc9PSIsInZhbHVlIjoiMzhWcWlFRXhJeHhhTmZ5QlhSSDdpUT09IiwibWFjIjoiNjhlODQ0MzQxMTg2NTM1MWViZTQ2M2RiNThjZDM4Yzc4ZTg2MGFiNDhkNTQ4MDA5MzE3YjFiNjg0YmY0YmY2YiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309351611",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085019",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "5b7e0fcf-9fb1-4800-9fec-064f41d7cfa6",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/dffd43ab-40b4-4630-b448-0b4019bfc9d1/app.js?property=dffd43ab-40b4-4630-b448-0b4019bfc9d1&propertyName=Arctic+Sun&channelUuid=c248fbdb-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47676658716",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBGWFNENGVwcWdOT2I2TThoYkxyNWc9PSIsInZhbHVlIjoiMzhWcWlFRXhJeHhhTmZ5QlhSSDdpUT09IiwibWFjIjoiNjhlODQ0MzQxMTg2NTM1MWViZTQ2M2RiNThjZDM4Yzc4ZTg2MGFiNDhkNTQ4MDA5MzE3YjFiNjg0YmY0YmY2YiJ9",
  "custom_audioeye_site_id": "92b5bfe9-a0c4-49e0-b6d5-0f27df0cf7b3",
  "custom_audioeye_site_hash": "e19fa8f354576eab4641de4511f543fc"
};

export const generatedAt = '2026-11-02T18:11:53.151Z';
